"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SecondaryDropdownItem = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _getClassesPropType = require("../../helpers/getClassesPropType");

var _useStyles = require("../../helpers/useStyles");

var _classnames = _interopRequireDefault(require("classnames"));

var _loadStyles = _interopRequireDefault(require("load-styles"));

var _usePropsUpdatedChildren = require("../../helpers/usePropsUpdatedChildren");

var _icon = require("./icon");

var _excluded = ["classes"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

(0, _loadStyles.default)(".c25154413{font-size:.875rem;font-weight:500;line-height:1.25rem;cursor:pointer;padding:.5rem .375rem;display:flex;align-items:center}.c25154413:hover:not(.c698b45f9):not(.cbb74005c):not(.cd7bfa32f){color:var(--color-black-d);background-color:var(--color-gray-10)}.cb1b5c904{font-size:.875rem;font-weight:400;line-height:1.25rem}.c01c27695{color:var(--color-gray-90)}.c01c27695 .c8f767025{color:var(--color-gray-80)}.c01c27695:hover:not(.c698b45f9):not(.cbb74005c) .c8f767025{color:var(--color-gray-90)}.c22003faf{color:var(--color-blue-90)}.c22003faf .c8f767025{color:var(--color-blue-80)}.c22003faf:hover:not(.c698b45f9):not(.cbb74005c) .c8f767025{color:var(--color-gray-90)}.cec6c2f05{color:var(--color-red-90)}.cec6c2f05 .c8f767025{color:var(--color-red-80)}.cec6c2f05:hover:not(.c698b45f9):not(.cbb74005c) .c8f767025{color:var(--color-gray-90)}.cd7bfa32f{color:var(--color-gray-70);font-size:.75rem;font-weight:600;line-height:1rem;text-transform:uppercase;cursor:default;padding-top:.625rem;padding-bottom:.625rem}.cd7bfa32f .c8f767025{color:var(--color-gray-60)}.c698b45f9{color:var(--color-gray-60);cursor:default}.c698b45f9 .c8f767025{color:var(--color-gray-50)}.cbb74005c{font-size:.875rem;font-weight:600;line-height:1.25rem;color:var(--color-blue-90);cursor:default}.cbb74005c .c8f767025{color:var(--color-blue-80)}");
var styles = {
  root: 'c25154413',
  '--disabled': 'c698b45f9',
  '--active': 'cbb74005c',
  '--view-header': 'cd7bfa32f',
  '--thin': 'cb1b5c904',
  '--view-usual': 'c01c27695',
  icon: 'c8f767025',
  '--view-bright': 'c22003faf',
  '--view-warning': 'cec6c2f05'
};

var SecondaryDropdownItem = function SecondaryDropdownItem(props) {
  var view = props.view,
      onClick = props.onClick,
      children = props.children,
      thin = props.thin,
      active = props.active,
      disabled = props.disabled,
      classes = props.classes;
  var cn = (0, _useStyles.useStyles)(styles, classes);
  var onClickHandler = (0, _react.useCallback)(function () {
    if (disabled || !onClick) return;
    return onClick.apply(void 0, arguments);
  }, [onClick, disabled]);
  var updateIconProps = (0, _react.useCallback)(function (_ref) {
    var classes = _ref.classes,
        rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
    return _objectSpread({
      classes: _objectSpread(_objectSpread({}, classes), {}, {
        root: (0, _classnames.default)(classes.root, cn.icon)
      })
    }, rest);
  }, [cn.icon]);
  var childTypesIcon = (0, _react.useMemo)(function () {
    return [_icon.SecondaryDropdownItemIcon];
  }, []);
  var updatedChildren = (0, _usePropsUpdatedChildren.usePropsUpdatedChildren)(children, childTypesIcon, updateIconProps);
  return /*#__PURE__*/_react.default.createElement("div", {
    onClick: onClickHandler,
    className: (0, _classnames.default)(cn.root, cn.view[view], (0, _defineProperty2.default)({}, cn.thin, thin), (0, _defineProperty2.default)({}, cn.active, active), (0, _defineProperty2.default)({}, cn.disabled, disabled))
  }, updatedChildren);
};

exports.SecondaryDropdownItem = SecondaryDropdownItem;
var view = ['usual', 'bright', 'warning', 'header'];
SecondaryDropdownItem.modes = {
  view: view
};
SecondaryDropdownItem.propTypes = {
  /* component logic props */
  onClick: _propTypes.func,
  children: _propTypes.node.isRequired,
  active: _propTypes.bool,
  disabled: _propTypes.bool,
  thin: _propTypes.bool,
  view: (0, _propTypes.oneOf)(view),

  /* classes */
  classes: (0, _getClassesPropType.getClassesPropType)(styles)
};
SecondaryDropdownItem.defaultProps = {
  view: 'usual',
  onClick: null,
  active: false,
  disabled: false,
  thin: false,
  classes: {}
};